import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordsMatch(password: string, comparePassword: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const passwordIsValid = control.value[password] === control.value[comparePassword];
        return passwordIsValid ? null : { passwordMatch: true };
    };
}
